import { setupAbstractContentBuilder } from "./AbstractContentBuilder";
import { addCollapsibleList } from "./collapsible-list-builder-api";
import { addListNode, addNode, addTextNode } from "./node-builder-methods";
import { addTable } from "./table-builder-api";
const firstLetterUpperCase = (str) => `${str.charAt(0).toUpperCase()}${str.substring(1)}`;
const setupContentBuilder = (generateId) => {
  class RicosContentBuilder {
  }
  const builderApis = setupAbstractContentBuilder(
    generateId,
    addTextNode,
    addListNode,
    addNode,
    addTable,
    addCollapsibleList,
    (name) => `add${firstLetterUpperCase(name)}`
    // addParagraph, addTable, ...
  );
  return {
    RicosContentBuilder,
    ...builderApis
  };
};
export {
  setupContentBuilder
};
//# sourceMappingURL=RicosContentBuilder.js.map
